<script setup lang="ts">
import {useModalStore} from '../../store/modal'

const modalStore = useModalStore()
</script>

<template>
<div class="filters-modal-container">
    <div class="filters-modal-header">
        <button class="filters-modal-header-cross-button" @click="modalStore.close()">
            <ah-icon name="cross-default" :size="24"/>
        </button>
    </div>
    <div class="filters-modal-body">
        <div class="filters-modal-content">
            <div class="filters-modal-content-heading">
                <p>Filters.</p>
                <button>Clear</button>
            </div>

            <brand-form-select label="Sorting." :options="['All', 'Open', 'Closed']" />
            <brand-form-select label="Status." :options="['All', 'Open', 'Closed']" />

            <div class="filters-modal-content-heading">
                <p>Date.</p>
                <button>Clear</button>
            </div>

            <brand-form-select label="Start date." :options="['All', 'Open', 'Closed']" />
            <brand-form-select label="End date." :options="['All', 'Open', 'Closed']" />
        </div>

        <div class="filters-modal-actions">
            <brand-button>Apply</brand-button>
            <button class="filters-download-button">
                <ah-icon name="arrow-in" :size="20"/>
            </button>
        </div>
    </div>
</div>
</template>

<style lang="scss">
.filters-modal-container {
    width: 100%;

    .filters-modal-header {
        height: 4.9rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .filters-modal-header-cross-button {
            height: 4.8rem;
            width: 4.8rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border: none;
            background: transparent;

            .icon {
                fill: var(--color-white);
            }
        }
    }

    .filters-modal-body {
        background: var(--color-grey-mist);
        border-radius: 2.4rem 2.4rem 0 0;
        padding: 3rem 1rem;

        .filters-modal-content {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            margin-bottom: 3rem;

            .filters-modal-content-heading {
                padding: 2rem;
                display: flex;
                align-items: center;
                justify-content: space-between;

                p {
                    @include font(1.6, 1.6, black);
                }

                button {
                    @include font(1.1,1.1,black);
                    padding: 0;
                    margin: 0;
                    border: none;
                    background: transparent;
                    color: #009991;
                }
            }
        }

        .filters-modal-actions {
            display: flex;
            align-items: center;
            gap: .5rem;

            .brand-button {
                flex: 1;
            }

            .filters-download-button {
                width: 6rem;
                height: 6rem;
                border-radius: 50%;
                background: var(--color-white);
                display: flex;
                justify-content: center;
                align-items: center;
                border: none;
                padding: 0;
                margin: 0;

                .icon {
                    fill: var(--color-grey-thunder);
                }
            }
        }

        @include dark() {
            background: var(--color-darth-sidious);

            .filters-download-button {
                background: var(--color-darth-maul);

                .icon {
                    fill: var(--color-white);
                }
            }
        }
    }
}
</style>
